import { removeData } from '@/services/storage.js'
import { clearZendeskToken } from '@/services/storageZendesk.js'
const jwt = require('jsonwebtoken')

export const redirectToExpired = () => {
  window.location.replace('/#/expired-session')
}

export const logout = () => {
  window.localStorage.removeItem('session-id')
  window.localStorage.removeItem('has-pii-access')
  window.localStorage.removeItem('loggedUser')
  window.localStorage.removeItem('fingerprint')
  window.localStorage.removeItem('is-admin')
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('multi-user-token')
  window.localStorage.removeItem('allowed-modules')
  window.localStorage.removeItem('security')
  window.localStorage.removeItem('id_account')
  window.localStorage.removeItem('is-multi-user')
  window.localStorage.removeItem('admin-configuration')
  window.localStorage.removeItem('authCode')
  removeData('franchiseePermissions')
  clearZendeskToken()
}

export default {
  install(Vue) {
    // Logged User
    const isLogged = () => {
      return window.localStorage.getItem('loggedUser') !== null
    }
    const getLoggedUser = () => {
      const user = JSON.parse(window.localStorage.getItem('loggedUser'))
      if (!user) return { name: '' }
      return user
    }
    const setLoggedUser = (loggedUser) => {
      if (!loggedUser) return
      window.localStorage.setItem('loggedUser', JSON.stringify(loggedUser))
    }

    const setFingerPrint = (fingerPrint) => {
      window.localStorage.setItem('fingerprint', JSON.stringify(fingerPrint))
    }
    const isOnTestOrDemoAccount = () => {
      const loggedUser = getLoggedUser()
      return loggedUser?.id_external === 0
    }

    // authCode
    const getAuthCode = () => {
      return window.localStorage.getItem('authCode')
    }
    const setAuthCode = (authCode) => {
      if (!authCode) return
      window.localStorage.setItem('authCode', authCode)
    }
    const removeAuthCode = () => {
      window.localStorage.removeItem('authCode')
    }

    // ecommerce
    const setIsEcommerce = (isEcommerce) => {
      window.localStorage.setItem('is-ecommerce', jwt.sign({ isEcommerce }, process.env.VUE_APP_JWT_KEY))
    }
    const getIsEcommerce = () => {
      try {
        let { isEcommerce } = jwt.verify(window.localStorage.getItem('is-ecommerce'), process.env.VUE_APP_JWT_KEY)
        return isEcommerce
      } catch {
        return false
      }
    }
    const setUseCatalogFlag = (useCatalogFlag) => {
      window.localStorage.setItem('use-catalog-flag', jwt.sign({ useCatalogFlag }, process.env.VUE_APP_JWT_KEY))
    }
    const getUseCatalogFlag = () => {
      try {
        let { useCatalogFlag } = jwt.verify(window.localStorage.getItem('use-catalog-flag'), process.env.VUE_APP_JWT_KEY)
        return useCatalogFlag
      } catch {
        return false
      }
    }

    // club
    const setIsClub = (isClub) => {
      window.localStorage.setItem('is-club', jwt.sign({ isClub }, process.env.VUE_APP_JWT_KEY))
    }
    const getIsClub = () => {
      try {
        let { isClub } = jwt.verify(window.localStorage.getItem('is-club'), process.env.VUE_APP_JWT_KEY)
        return isClub
      } catch {
        return false
      }
    }

    // Is MultiUser
    const setIsMultiUser = (isMultiUser) => {
      window.localStorage.setItem('is-multi-user', jwt.sign({ isMultiUser }, process.env.VUE_APP_JWT_KEY))
    }

    const getIsMultiUser = () => {
      try {
        let { isMultiUser } = jwt.verify(window.localStorage.getItem('is-multi-user'), process.env.VUE_APP_JWT_KEY)
        return isMultiUser
      } catch {
        return false
      }
    }
    const removeIsMultiUser = () => {
      window.localStorage.removeItem('is-multi-user')
    }

    // Is Admin
    const setIsAdmin = (isAdmin) => {
      window.localStorage.setItem('is-admin', jwt.sign({ isAdmin }, process.env.VUE_APP_JWT_KEY))
    }

    const getIsAdmin = () => {
      try {
        let { isAdmin } = jwt.verify(window.localStorage.getItem('is-admin'), process.env.VUE_APP_JWT_KEY)
        return isAdmin
      } catch {
        return false
      }
    }
    const removeIsAdmin = () => {
      window.localStorage.removeItem('is-admin')
    }

    // First Value
    const getFirstValue = () => {
      return getAllowedModules()['primeiro_valor']
    }

    // Allowed modules
    const getAllowedModules = () => {
      try {
        let { modules: allowedModules } = jwt.verify(window.localStorage.getItem('allowed-modules'), process.env.VUE_APP_JWT_KEY)
        return allowedModules
      } catch {
        return false
      }
    }

    const getSecurity = () => {
      try {
        let { security } = jwt.verify(window.localStorage.getItem('security'), process.env.VUE_APP_JWT_KEY)
        return security
      } catch {
        return {}
      }
    }

    const setAllowedModules = (allowedModules) => {
      if (!allowedModules) return
      window.localStorage.setItem('allowed-modules', jwt.sign({ modules: allowedModules }, process.env.VUE_APP_JWT_KEY))
    }

    const setSecurity = (security) => {
      if (!security) return
      window.localStorage.setItem('security', jwt.sign({ security }, process.env.VUE_APP_JWT_KEY))
    }

    // Has PII Access
    const setPiiAccess = (hasPiiAccess) => {
      window.localStorage.setItem('has-pii-access', jwt.sign({ hasPiiAccess }, process.env.VUE_APP_JWT_KEY))
    }

    const hasPiiAccess = () => {
      try {
        let { hasPiiAccess } = jwt.verify(window.localStorage.getItem('has-pii-access'), process.env.VUE_APP_JWT_KEY)
        return hasPiiAccess
      } catch {
        return false
      }
    }

    // Has PII Download Access
    const setPiiDownloadAccess = (hasPiiDownloadAccess) => {
      window.localStorage.setItem('has-pii-download-access', jwt.sign({ hasPiiDownloadAccess }, process.env.VUE_APP_JWT_KEY))
    }

    const hasPiiDownloadAccess = () => {
      try {
        let { hasPiiDownloadAccess } = jwt.verify(window.localStorage.getItem('has-pii-download-access'), process.env.VUE_APP_JWT_KEY)
        return hasPiiDownloadAccess
      } catch {
        return false
      }
    }

    // Has PII Employees Access
    const setPiiEmployeesAccess = (hasPiiEmployeesAccess) => {
      window.localStorage.setItem('has-pii-employees-access', jwt.sign({ hasPiiEmployeesAccess }, process.env.VUE_APP_JWT_KEY))
    }

    const hasPiiEmployeesAccess = () => {
      try {
        let { hasPiiEmployeesAccess } = jwt.verify(window.localStorage.getItem('has-pii-employees-access'), process.env.VUE_APP_JWT_KEY)
        return hasPiiEmployeesAccess
      } catch {
        return false
      }
    }

    // Logged User
    Vue.prototype.$isLogged = Vue.isLogged = isLogged
    Vue.prototype.$getLoggedUser = Vue.getLoggedUser = getLoggedUser
    Vue.prototype.$setLoggedUser = Vue.setLoggedUser = setLoggedUser
    Vue.prototype.$setFingerPrint = Vue.setFingerPrint = setFingerPrint
    Vue.prototype.$isOnTestOrDemoAccount = Vue.isOnTestOrDemoAccount = isOnTestOrDemoAccount

    // authCode
    Vue.prototype.$getAuthCode = Vue.getAuthCode = getAuthCode
    Vue.prototype.$setAuthCode = Vue.setAuthCode = setAuthCode
    Vue.prototype.$removeAuthCode = Vue.removeAuthCode = removeAuthCode

    // Is Admin
    Vue.prototype.$getIsAdmin = Vue.getIsAdmin = getIsAdmin
    Vue.prototype.$setIsAdmin = Vue.setIsAdmin = setIsAdmin
    Vue.prototype.$removeIsAdmin = Vue.removeIsAdmin = removeIsAdmin

    // ecommerce
    Vue.prototype.$setIsEcommerce = Vue.setIsEcommerce = setIsEcommerce
    Vue.prototype.$getIsEcommerce = Vue.getIsEcommerce = getIsEcommerce
    Vue.prototype.$setUseCatalogFlag = Vue.setUseCatalogFlag = setUseCatalogFlag
    Vue.prototype.$getUseCatalogFlag = Vue.getUseCatalogFlag = getUseCatalogFlag

    // club
    Vue.prototype.$setIsClub = Vue.setIsClub = setIsClub
    Vue.prototype.$getIsClub = Vue.getIsClub = getIsClub

    // Is MultiUser
    Vue.prototype.$getIsMultiUser = Vue.getIsMultiUser = getIsMultiUser
    Vue.prototype.$setIsMultiUser = Vue.setIsMultiUser = setIsMultiUser
    Vue.prototype.$removeIsMultiUser = Vue.removeIsMultiUser = removeIsMultiUser

    // First Value
    Vue.prototype.$getFirstValue = Vue.getFirstValue = getFirstValue

    // Logout
    Vue.prototype.$logout = Vue.logout = logout

    // Allowed modules
    Vue.prototype.$getAllowedModules = Vue.getAllowedModules = getAllowedModules
    Vue.prototype.$setAllowedModules = Vue.setAllowedModules = setAllowedModules

    // Security
    Vue.prototype.$getSecurity = Vue.getSecurity = getSecurity
    Vue.prototype.$setSecurity = Vue.setSecurity = setSecurity

    // Has PII access
    Vue.prototype.$hasPiiAccess = Vue.hasPiiAccess = hasPiiAccess
    Vue.prototype.$setPiiAccess = Vue.setPiiAccess = setPiiAccess

    // Has PII Download access
    Vue.prototype.$hasPiiDownloadAccess = Vue.hasPiiDownloadAccess = hasPiiDownloadAccess
    Vue.prototype.$setPiiDownloadAccess = Vue.setPiiDownloadAccess = setPiiDownloadAccess

    // Has PII Employees access
    Vue.prototype.$hasPiiEmployeesAccess = Vue.hasPiiEmployeesAccess = hasPiiEmployeesAccess
    Vue.prototype.$setPiiEmployeesAccess = Vue.setPiiEmployeesAccess = setPiiEmployeesAccess

    Object.defineProperty(Vue.prototype, '$loggedUser', {
      get: () => {
        return getLoggedUser()
      },
    })

    Object.defineProperty(Vue, 'loggedUser', {
      get: () => {
        return getLoggedUser()
      },
    })
  },
}
